import {socketHandler} from "../../common/functions";
import {socket} from "../../store/actions";

const useSocket = (cb) => {
    const handler = r => cb(socketHandler(r))
    return {
        refresh: () => {
            socket.off('response', handler)
            socket.on('response', handler)
        },
        on: () => socket.on('response', handler),
        off: () => socket.off('response', handler)
    }
};

export default useSocket;